exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-title[data-v-0bb9c32e] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n}\n.grid-title h4[data-v-0bb9c32e] {\n  margin-top: 0;\n}", ""]);

// exports
